import Bouncer from 'formbouncerjs';

const handleEmailSubmission = () => {
    const emailInput = document.querySelector<HTMLInputElement>('input#email');
    const propertyNameInput = document.querySelector<HTMLInputElement>('input#propertyName');
    const propertyTypeInput = document.querySelector<HTMLInputElement>('input#propertyType');
    const form = document.querySelector<HTMLElement>('form.brochure-request-form');
    const submitBtn = form?.querySelector<HTMLButtonElement>('.js-submit');

    const stepTwo = document.querySelector<HTMLElement>('.multistep-modal-content.step-two');
    const stepThree = document.querySelector<HTMLElement>('.multistep-modal-content.step-three');

    const stepTwoBtn = stepTwo?.querySelector<HTMLElement>('.multistep-modal-btn');
    const stepTwoLoaderBtn = stepTwo?.querySelector<HTMLElement>('.multistep-modal-btn');

    const notificationSuccess = document.querySelector<HTMLElement>('.notification-success');
    const notificationError = document.querySelector<HTMLElement>('.notification-error');

    Bouncer('form.brochure-request-form');

    submitBtn?.addEventListener('click', e => {
        e.preventDefault();
        const data = {
            emailAddress: emailInput?.value,
            pageUrl: window.location.href,
            propertyName: propertyNameInput?.value,
            propertyType: propertyTypeInput?.value
        };

        if (!!emailInput?.value && !emailInput?.classList.contains('error')) {
            stepTwoBtn?.classList.add('hidden');
            stepTwoLoaderBtn?.classList.remove('hidden');

            fetch('/propertyactions/download', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            }).then(response => {
                if (response.ok) {
                    notificationSuccess?.classList.remove('hidden');
                    notificationError?.classList.add('hidden');
                } else {
                    notificationError?.classList.remove('hidden');
                    notificationSuccess?.classList.add('hidden');
                }

                if (stepTwo && stepThree) {
                    stepTwo.style.visibility = 'hidden';
                    stepTwo.style.opacity = '0';
                    stepTwo.style.height = '0';
                    stepTwo.style.position = 'absolute';
                    stepThree.style.visibility = 'visible';
                    stepThree.style.opacity = '1';
                    stepThree.style.height = 'auto';
                    stepThree.style.position = 'static';
                }
            });
        }
    });
};

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', () => {
    const body = document.querySelector<HTMLElement>('body');
    const multistepModalContainer = document.querySelector<HTMLElement>('.multistep-modal-cta');
    const stepOne = document.querySelector<HTMLElement>('.multistep-modal-content.step-one');
    const stepTwo = document.querySelector<HTMLElement>('.multistep-modal-content.step-two');
    const stepOneBtn = stepOne?.querySelector<HTMLElement>('.multistep-modal-btn');
    const closeBtns = document.querySelectorAll<HTMLElement>('.js-modal-close');

    if (multistepModalContainer?.classList.contains('show-on-scroll') && body) {
        window.addEventListener('scroll', () => {
            const currentScrollY = document.documentElement.scrollTop;
            if (currentScrollY >= (body.scrollHeight / 2)) {
                multistepModalContainer.style.visibility = 'visible';
                multistepModalContainer.style.opacity = '1';
            }
        });
    }

    if (multistepModalContainer?.classList.contains('show-with-delay')) {
        setTimeout(() => {
            multistepModalContainer.style.visibility = 'visible';
            multistepModalContainer.style.opacity = '1';
        }, 15000);
    }

    stepOneBtn?.addEventListener('click', () => {
        if (stepOne && stepTwo) {
            stepOne.style.visibility = 'hidden';
            stepOne.style.opacity = '0';
            stepOne.style.height = '0';
            stepOne.style.position = 'absolute';
            stepTwo.style.visibility = 'visible';
            stepTwo.style.opacity = '1';
            stepTwo.style.height = 'auto';
            stepTwo.style.position = 'static';
            handleEmailSubmission();
        }
    });

    Array.from(closeBtns).forEach(btn => {
        btn.addEventListener('click', () => {
            if (multistepModalContainer) {
                multistepModalContainer.style.display = 'none';
            }
        });
    });
});
